import React, { Component } from 'react'
import site_config from "SiteConfig/main.js"

class BasePage extends Component {
    constructor(props){
        super(props);
        document.title = site_config.title
    }
    render() {
        return (
            <div>{this.constructor.name} tab</div>
        )
    }
}

export default BasePage



// WEBPACK FOOTER //
// ./src/lib/base/Page.js